const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getAllSubAnchors = async (anchorId, page = 1, itemsPerPage = 5) => {
  try {
    const token = localStorage.getItem("authToken");
    const response = await fetch(
      `${BASE_URL}/eci/apis/v4/wallets/${anchorId}/get_dsa_wallets?page=${page}&items=${itemsPerPage}`, 
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch sub anchors");
    }

    const data = await response.json();
    return {
      items: data.msg?.items || [],
      pagination: data.msg?.pagination || {}
    };
  } catch (error) {
    console.error("Error fetching sub anchors:", error);
    throw error;
  }
};

/**
 * Get subanchor details (code, mobile, email) for display and edit form prefilling.
 * GET .../wallets/{anchor_id}/get_subanchor_info/{wallet_id}
 */
export const getSubanchorInfo = async (anchorId, walletId) => {
  const token = localStorage.getItem("authToken");
  const response = await fetch(
    `${BASE_URL}/eci/apis/v4/wallets/${anchorId}/get_subanchor_info/${walletId}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  const data = await response.json();

  if (!response.ok || data?.metadata?.api_status === false) {
    const msg = typeof data?.msg === "string" ? data.msg : "Failed to fetch subanchor info";
    throw new Error(msg);
  }

  return data.msg; // { code, mobile, email }
};

/**
 * Create a subanchor (DSA wallet) under an anchor.
 * @param {string} anchorId - UUID of the anchor
 * @param {{ code: string, mobile?: number, email?: string }} payload - code (required), mobile and email optional
 * @returns {Promise<{ msg: string, metadata: { api_status: boolean } }>}
 */
export const createSubanchor = async (anchorId, payload) => {
  const token = localStorage.getItem("authToken");
  const response = await fetch(
    `${BASE_URL}/eci/apis/v4/wallets/${anchorId}/create_subanchor`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }
  );

  const data = await response.json();

  if (!response.ok) {
    const err = new Error(
      Array.isArray(data?.msg)
        ? data.msg.map((e) => e?.value ?? e).join(" ")
        : typeof data?.msg === "string"
          ? data.msg
          : "Failed to create subanchor"
    );
    err.status = response.status;
    err.data = data;
    throw err;
  }

  return data;
};

/**
 * Edit a subanchor (DSA wallet). Partial update – send only fields to change.
 * POST .../wallets/{anchor_id}/dsa_wallets/{wallet_id}
 */
export const updateSubanchor = async (anchorId, walletId, payload) => {
  const token = localStorage.getItem("authToken");
  const response = await fetch(
    `${BASE_URL}/eci/apis/v4/wallets/${anchorId}/dsa_wallets/${walletId}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }
  );

  const data = await response.json();

  if (!response.ok) {
    const err = new Error(
      Array.isArray(data?.msg)
        ? data.msg.map((e) => e?.value ?? e).join(" ")
        : typeof data?.msg === "object" && data?.msg?.detail
          ? data.msg.detail
          : typeof data?.msg === "string"
            ? data.msg
            : "Failed to update subanchor"
    );
    err.status = response.status;
    err.data = data;
    throw err;
  }

  return data;
};
